export default __webpack_public_path__ + "static/media/Edit-not.dc0d3de9.svg";